import React from 'react';
import ContactForm from '../components/ContactForm';

const Kontakt = () => {
  return (
    <div className="pt-20">
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
        <img 
          src="/media/billeder/Fliser/IMG_0047.jpeg" 
          alt="Background" 
          className="absolute inset-0 w-full h-full object-cover opacity-90"
        />
        
        <div className="relative z-10 w-full px-4 py-20">
          <h1 className="text-5xl md:text-6xl font-bold text-white text-center mb-12 text-shadow-strong uppercase">
            Kontakt os
          </h1>
          
          <div className="max-w-3xl mx-auto">
            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Kontakt;
